import React from 'react';

import Block from '@cloudhub-ux/core/Block';
import Button from '@cloudhub-ux/core/Button';
import Input from '@cloudhub-ux/core/Input';
import TextArea from '@cloudhub-ux/core/TextArea';
import FieldBlock from '@cloudhub-ux/core/FieldBlock';
import { formCalculate, Form, Field } from '@cloudhub-ux/core/form';
import Alert from '@cloudhub-ux/core/Alert';
import Dialog from '@cloudhub-ux/core/dialogs/Dialog';
import DialogHeader from '@cloudhub-ux/core/dialogs/DialogHeader';
import DialogContent from '@cloudhub-ux/core/dialogs/DialogContent';
import DialogActions from '@cloudhub-ux/core/dialogs/DialogActions';
import { colors } from 'theme';

import useAdminAxios from 'admin/context/useAdminAxios';
import ImagesUpload from '@cloudhub-ux/core/uploaders/uploader/ImagesUpload';

const calculator = formCalculate({
  field: ['MediahouseName'],
  updates: {
    MediahouseCode: (value, values) =>
      `${values.MediahouseName}`.toLocaleLowerCase().replace(/ /g, '_'),
  },
});

const MediahouseForm = (props) => {
  const { postData, error, reset } = useAdminAxios();

  const onSaveMediahouse = async (values) => {
    const data = await postData({
      url: '/website/mediahouse/savemediahouse',
      params: {
        ...values,
      },
    });

    if (data) {
      props.onSave(data);
      props.onCancelEdit();
    }
  };

  const { editingRow } = props;
  const values = editingRow || {};

  const title = values.id
    ? values.MediahouseName || 'Edit Mediahouse'
    : 'Add Mediahouse';

  return (
    <Dialog
      open={editingRow !== null}
      onClose={props.onCancelEdit}
      minHeight={700}
    >
      <DialogHeader onClose={props.onCancelEdit}>{`${title}`}</DialogHeader>

      <Form
        onSubmit={onSaveMediahouse}
        decorators={[calculator]}
        initialValues={editingRow || {}}
        render={({ handleSubmit, submitting, pristine }) => (
          <React.Fragment>
            <DialogContent>
              <Block>
                <Block>
                  <FieldBlock row>
                    <Field
                      label="Media House Name"
                      name="MediahouseName"
                      component={Input}
                      required
                      flex
                    />
                    <Field
                      label="Website"
                      name="Website"
                      component={Input}
                      flex
                    />
                  </FieldBlock>
                  <FieldBlock row>
                    <Field
                      label="Contact Person"
                      name="ContactPerson"
                      component={Input}
                      flex
                    />

                    <Field label="Phone" name="Phone" component={Input} flex />
                    <Field label="Email" name="Email" component={Input} flex />
                  </FieldBlock>

                  <Block row top>
                    <Block flex={false}>
                      <Field
                        label="Media House Code"
                        name="MediahouseCode"
                        component={Input}
                        required
                      />
                      <Field
                        label="Voting Code"
                        name="VotingCode"
                        component={Input}
                      />
                      <Block flex={false} style={{ width: 300 }}>
                        <Field
                          label="Mediahouse Logo"
                          name="MediahouseImage"
                          component={ImagesUpload}
                          maxSize={300}
                        />
                      </Block>
                    </Block>
                    <Block style={{ marginLeft: 5 }}>
                      <Field
                        label="Description"
                        name="Description"
                        component={TextArea}
                        maxLength={1000}
                        rows={15}
                      />
                    </Block>
                  </Block>
                </Block>
              </Block>
            </DialogContent>

            <DialogActions>
              <Block>
                {Boolean(error) && (
                  <Alert error message={error} onClose={() => reset()} />
                )}
              </Block>
              <Button
                contained
                color={colors.danger}
                onClick={props.onCancelEdit}
                disabled={submitting}
              >
                Cancel
              </Button>

              <Button
                contained
                color={colors.success}
                onClick={handleSubmit}
                disabled={submitting || pristine}
              >
                {submitting ? 'Please wait...' : 'Save'}
              </Button>
            </DialogActions>
          </React.Fragment>
        )}
      />
    </Dialog>
  );
};

MediahouseForm.defaultProps = {
  onSave: () => {},
};

export default MediahouseForm;
